module.exports = __webpack_public_path__ + "static/media/exchange.66b390a4.svg";